import {
  sendAnswerSelectionEvent,
  sendContextualHelpLinkSelectedEvent,
  sendCPQAQuestionsDisplayedEvent,
  sendEssentialSelectionEvent,
  sendPreferredAnswerNotSelectedEvent,
  sendQuestionAddedEvent,
  sendQuestionDeletedEvent,
  sendQuestionLimitReachedEvent,
  sendQuestionsDisplayedEvent,
  sendQuestionSelectionEvent,
  sendQuestionsSearchedEvent,
  sendSearchInteractedEvent,
  sendVerifyBoostContinueEvent,
  sendVerifyBoostNoQuestionSelectedEvent,
  sendVerifyBoostSelectionEvent,
} from './events';
import { setTestingId, resetTestingId } from './events/experiments';
import type { AnalyticalEvents, RoleRequirementsEvent } from './types';

export const getAvailableEvents = (
  onEvent: (event: RoleRequirementsEvent) => void,
  unifiedAnalytics: boolean,
): AnalyticalEvents => ({
  sendQuestionsDisplayedEvent: sendQuestionsDisplayedEvent(
    onEvent,
    unifiedAnalytics,
  ),
  sendAnswerSelectionEvent: sendAnswerSelectionEvent(onEvent, unifiedAnalytics),
  sendQuestionSelectionEvent: sendQuestionSelectionEvent(
    onEvent,
    unifiedAnalytics,
  ),
  sendEssentialSelectionEvent: sendEssentialSelectionEvent(
    onEvent,
    unifiedAnalytics,
  ),
  sendPreferredAnswerNotSelectedEvent: sendPreferredAnswerNotSelectedEvent(
    onEvent,
    unifiedAnalytics,
  ),
  sendQuestionLimitReachedEvent: sendQuestionLimitReachedEvent(
    onEvent,
    unifiedAnalytics,
  ),
  sendContextualHelpLinkSelectedEvent: sendContextualHelpLinkSelectedEvent(
    onEvent,
    unifiedAnalytics,
  ),
  sendSearchInteractedEvent: sendSearchInteractedEvent(
    onEvent,
    unifiedAnalytics,
  ),
  sendQuestionsSearchedEvent: sendQuestionsSearchedEvent(
    onEvent,
    unifiedAnalytics,
  ),
  sendQuestionAddedEvent: sendQuestionAddedEvent(onEvent, unifiedAnalytics),
  sendQuestionDeletedEvent: sendQuestionDeletedEvent(onEvent, unifiedAnalytics),
  sendCPQAQuestionsDisplayedEvent: sendCPQAQuestionsDisplayedEvent(onEvent),
  sendVerifyBoostSelectionEvent: sendVerifyBoostSelectionEvent(onEvent),
  sendVerifyBoostNoQuestionSelectedEvent:
    sendVerifyBoostNoQuestionSelectedEvent(onEvent),
  sendVerifyBoostContinueEvent: sendVerifyBoostContinueEvent(onEvent),
  setTestingId,
  resetTestingId,
});
